<template>
  <section class="contacts">
    <div class="container">
      <h3>Контакты</h3>
      <div class="row">
        <div class="col-3">
          <div class="group">
            <small>Email:</small>
            <p>{{ mailAddress }}</p>
          </div>
          <div class="group">
            <small>Телефон:</small>
            <Phone
                v-for="item in phoneList"
                v-bind:item = "item"
            />
          </div>
        </div>
        <div class="col-3">
          <div class="group">
            <small>Офис:</small>
            <p>{{ officeAddress }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import Phone from "@/components/Phone";

export default {
  name: 'SectionContacts',
  components: {Phone},
  methods: {},
  computed: {
    ...mapGetters ([
      'phoneList',
      'mailAddress',
      'officeAddress'
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.contacts {
  padding: 45px 0;
  @media (max-width: 997.98px) {
    padding: 20px 0;
  }
  h3 {
    font-weight: 500;
    font-size: 4rem;
    margin-bottom: 20px;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    .col-3 {
      flex: 0 0 33.333%;
      max-width: 33.333%;
      padding: 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      @media (max-width: 997.98px) {
        flex: 0 0 100%;
        max-width: 100%;
        display: flex;
      }
      .group {
        margin-bottom: 30px;
        @media (max-width: 997.98px) {
          margin-right: 30px;
        }
        small {
          font-weight: 300;
          font-size: 1.8rem;
          color: #828282;
          margin-bottom: 15px;
          display: block;
        }
        p {
          font-size: 2rem;
          color: #4F4F4F;
          @media (max-width: 566.98px) {
            font-size: 1.6rem;
          }
        }
      }
    }
  }
}
</style>
